import { render, staticRenderFns } from "./elc-comunidad.vue?vue&type=template&id=23face28"
import script from "./elc-comunidad.vue?vue&type=script&lang=js"
export * from "./elc-comunidad.vue?vue&type=script&lang=js"
import style0 from "./elc-comunidad.vue?vue&type=style&index=0&id=23face28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports